import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    error: '',
    loading: false,
    summaryInfo: {},
    rack: {},
};

const getters = {
    summaryInfo: state => state.summaryInfo,
    rack: state => state.rack,
};

const mutations = {
    [types.SUMMARY_INFO_REQUEST](state){
        state.loading = true;
        state.error = '';
        state.summaryInfo = {};
    },
    [types.SUMMARY_INFO_FAILURE](state, error){
        state.loading = false;
        state.error = error;
        state.summaryInfo = {};
    },
    [types.SUMMARY_INFO_SUCCESS](state, summaryInfo){
        state.loading = false;
        state.error = '';
        state.summaryInfo = summaryInfo;
    },
    [types.GET_RACK_REQUEST](state){
        state.loading = true;
        state.error = '';
        state.rack = {};
    },
    [types.GET_RACK_FAILURE](state, error){
        state.loading = false;
        state.error = error;
        state.rack = {};
    },
    [types.GET_RACK_SUCCESS](state, rack){
        state.loading = false;
        state.error = '';
        state.rack = rack;
    },
}
export default{
    state,
    actions,
    getters,
    mutations
}
